// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1qVDH","name":"Header_name__WcsBw","birthday":"Header_birthday__2WySn","skeleton":"Header_skeleton__2R-yQ"};